var dropdownContent = 'fx_2d2fb1e5_5yie6t0';

export { dropdownContent };
//# sourceMappingURL=content.vanilla.mjs.map
